import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQVertriebSection = () => <FAQSectionI18n translationPrefix="vertriebSolution" />;
export default FAQVertriebSection;
